import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useRemotePulls from "../../../../hooks/queryResults/remote/useRemotePulls";
import Util from "../../../../util/util";
import Table from "../../../layout/Table";
import TimeAgo from "../../../ui/TimeAgo";

export default function AdminRemoteRecentPullsTable() {
  const { pulls } = useRemotePulls();

  const pullColumns = useMemo(
    () => [
      { Header: "Id", accessor: "id" },
      { Header: "Template", accessor: "template" },
      { Header: "Source", accessor: "source" },
      { Header: "Url", accessor: "url" },
      { Header: "Started", accessor: "startDate" },
      { Header: "Took", accessor: "took" },
      { Header: "All", accessor: "all" },
      { Header: "Delete", accessor: "delete" },
    ],
    []
  );

  const pullData = useMemo(() => {
    const getPullsData = (pulls) => {
      const data = [];
      if (pulls) {
        pulls.forEach((pull) => {
          const domainSlug = pull.remoteTemplateSlug.split("_")[0];

          const row = {
            id: (
              <Link
                to={`/admin/remote/${domainSlug}/${pull.remoteTemplateSlug}/${pull.remoteSource}/${pull.id}`}
              >
                {pull.id}
              </Link>
            ),
            template: (
              <Link
                to={`/admin/remote/${domainSlug}/${pull.remoteTemplateSlug}`}
              >
                {pull.remoteTemplateSlug}
              </Link>
            ),
            source: (
              <Link
                to={`/admin/remote/${domainSlug}/${pull.remoteTemplateSlug}/${pull.remoteSource}`}
              >
                {pull.remoteSourceSlug}
              </Link>
            ),
            url: "url",
            startDate: <TimeAgo date={pull.all.startDate} />,
            took: Util.formatTimeInSeconds(pull.all.took),
          };
          const phase = pull.all;
          const took = Util.formatTimeInSeconds(phase.took);
          row.all = (
            <span title={took}>
              <Link
                style={{ textDecoration: "none" }}
                to={`/admin/remote/${domainSlug}/${pull.remoteTemplateSlug}/${pull.remoteSource}/${pull.id}`}
              >
                {Util.getProgressIcon(phase.progress)}
              </Link>
            </span>
          );
          row.delete = (
            <button
              // onClick={() => pullDeleteMutation.mutate(pull.id)}
              className={"btn btn-alert"}
            >
              delete
            </button>
          );

          data.push(row);
        });
      }

      return data;
    };
    return getPullsData(pulls);
  }, [pulls]);

  return (
    <>
      <h2>Recent Pulls</h2>
      <Table columns={pullColumns} data={pullData} />
    </>
  );
}
